webpackJsonp([288],{

/***/ 1334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiskUserDetail_vue__ = __webpack_require__(3108);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ff59fe6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiskUserDetail_vue__ = __webpack_require__(5856);
function injectStyle (ssrContext) {
  __webpack_require__(5854)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ff59fe6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiskUserDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ff59fe6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiskUserDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    isRiskStatus: function isRiskStatus(row) {
      return Number(row.risk_status) === 1;
    },
    isHighInvalidPercent: function isHighInvalidPercent(row) {
      return row.total_invalid_percent >= 70;
    },
    isCustomerRisk: function isCustomerRisk(row) {
      return row && row.order_percent >= 80;
    }
  }
});

/***/ }),

/***/ 3108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_users_user_risk_mixins__ = __webpack_require__(2505);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__views_users_user_risk_mixins__["a" /* default */]],
  data: function data() {
    return {
      id: this.$route.params.id,
      detail: {
        userid: null,
        cellphone: null,
        province_name: null,
        city_name: null,
        area_name: null,
        risk_status: null,
        confirm_status: null,
        total_pass_order_count: null,
        total_invalid_percent: null,
        confirmed_adminusername: '',
        confirmed_adminuserid: '',
        confirmed_logs: [],
        customer_stats: [],
        confirmed_at: null,
        became_risk_at: null,
        config: {
          risk_customer_confirm_percent: 0,
          risk_invalid_percent: 0
        }
      },
      remark: '',
      confirmLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    riskusersOpts: function riskusersOpts(state) {
      return state.users.riskusersOpts;
    }
  }), {
    regionText: function regionText() {
      var d = this.detail;
      if (!d || !d.userid) {
        return '';
      }
      return '' + (d.province_name || '') + (d.city_name || '') + (d.area_name || '');
    },
    totalInvalidPercentText: function totalInvalidPercentText() {
      var val = this.detail.total_invalid_percent;
      return val === null || val === undefined || val === '' ? '' : val + '%';
    },
    riskStatusText: function riskStatusText() {
      return this.riskusersOpts.riskStatusOpts[this.detail.risk_status] || '';
    },
    confirmStatusText: function confirmStatusText() {
      return this.riskusersOpts.riskConfirmStatusOpts[this.detail.confirm_status] || '';
    },
    riskReasons: function riskReasons() {
      var _this = this;

      var reasons = [];
      if (Number(this.detail.risk_status) !== 1) {
        return reasons;
      }
      if (this.detail.customer_stats.find(function (it) {
        return it.order_percent >= _this.detail.config.risk_customer_confirm_percent;
      })) {
        reasons.push('单一客户完单率');
      }
      if (this.detail.total_invalid_percent >= this.detail.config.risk_invalid_percent) {
        reasons.push('工单失效率');
      }
      return reasons;
    },
    adminusernameText: function adminusernameText() {
      if (!this.detail.confirmed_adminuserid) {
        return '';
      }
      return this.detail.confirmed_adminusername + ' / ' + this.detail.confirmed_adminuserid;
    },
    confirmLogList: function confirmLogList() {
      return this.detail.confirmed_logs.reverse();
    }
  }),
  created: function created() {
    this.setDetailData();
  },

  methods: {
    setDetailData: function setDetailData() {
      var _this2 = this;

      request.common('getRiskUserDetail', { userid: this.id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this2.detail, data);
      });
    },
    onConfirmRisk: function onConfirmRisk() {
      var _this3 = this;

      this.$confirm('确认将该零工标记为风险用户？', '确认风险', { type: 'warning' }).then(function () {
        _this3.submitConfirm(1);
      }).catch(function () {});
    },
    onConfirmNormal: function onConfirmNormal() {
      var _this4 = this;

      this.$confirm('确认将该零工标记为正常用户？', '确认正常', { type: 'warning' }).then(function () {
        _this4.submitConfirm(2);
      }).catch(function () {});
    },
    submitConfirm: function submitConfirm(riskStatus) {
      var _this5 = this;

      this.confirmLoading = true;
      request.common('confirmRiskUser', {
        userid: this.id,
        risk_status: riskStatus,
        remark: this.remark
      }).then(function () {
        _this5.$message.success('确认成功');
        _this5.setDetailData();
      }).finally(function () {
        _this5.confirmLoading = false;
      });
    }
  }
});

/***/ }),

/***/ 5854:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5855);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("fa450e56", content, true, {});

/***/ }),

/***/ 5855:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".form-item__detail[data-v-9ff59fe6]{border:1px solid #e4e7ed;background:#f5f7fa;border-radius:4px;padding:0 10px;height:38px}.risk-user-customer-stats[data-v-9ff59fe6]{min-height:36px;line-height:36px;font-size:14px;padding:10px;color:#606266;background:#f5f7fa;border:1px solid #e4e7ed;border-radius:5px}.is-risk[data-v-9ff59fe6]{color:#f56c6c!important}.re-el-form__triple_grid[data-v-9ff59fe6]{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-bottom:20px}.re-el-form__triple_grid .el-form-item[data-v-9ff59fe6]{margin-bottom:0!important}.re-el-form__triple_grid[data-v-9ff59fe6] .el-form-item__label{font-weight:700}.re-el-form_single_grid[data-v-9ff59fe6]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:20px}.re-el-form_single_grid[data-v-9ff59fe6] .el-form-item__label{font-weight:700}", "", {"version":3,"sources":["/workspace/src/views/users/pages/detail/RiskUserDetail.vue"],"names":[],"mappings":"AACA,oCAAoC,yBAAyB,mBAAmB,kBAAkB,eAAe,WAAW,CAC3H,AACD,2CAA2C,gBAAgB,iBAAiB,eAAe,aAAa,cAAc,mBAAmB,yBAAyB,iBAAiB,CAClL,AACD,0BAA0B,uBAAwB,CACjD,AACD,0CAA0C,aAAa,oCAAqC,SAAS,kBAAkB,CACtH,AACD,wDAAwD,yBAA0B,CACjF,AACD,+DAA+D,eAAgB,CAC9E,AACD,yCAAyC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,8BAA8B,QAAQ,CAC7T,AACD,8DAA8D,eAAgB,CAC7E","file":"RiskUserDetail.vue","sourcesContent":["\n.form-item__detail[data-v-9ff59fe6]{border:1px solid #E4E7ED;background:#F5F7FA;border-radius:4px;padding:0 10px;height:38px\n}\n.risk-user-customer-stats[data-v-9ff59fe6]{min-height:36px;line-height:36px;font-size:14px;padding:10px;color:#606266;background:#F5F7FA;border:1px solid #E4E7ED;border-radius:5px\n}\n.is-risk[data-v-9ff59fe6]{color:#f56c6c !important\n}\n.re-el-form__triple_grid[data-v-9ff59fe6]{display:grid;grid-template-columns:repeat(3, 1fr);gap:20px;margin-bottom:20px\n}\n.re-el-form__triple_grid .el-form-item[data-v-9ff59fe6]{margin-bottom:0 !important\n}\n.re-el-form__triple_grid[data-v-9ff59fe6] .el-form-item__label{font-weight:bold\n}\n.re-el-form_single_grid[data-v-9ff59fe6]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:20px\n}\n.re-el-form_single_grid[data-v-9ff59fe6] .el-form-item__label{font-weight:bold\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('layout-panel',{attrs:{"hide-collapse":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("基础信息")]},proxy:true}])},[_vm._v(" "),_c('el-form',{attrs:{"label-width":"120px","label-position":"top","size":"medium"}},[_c('div',{staticClass:"re-el-form__triple_grid"},[_c('el-form-item',{attrs:{"label":"零工ID"}},[_c('div',{staticClass:"form-item__detail"},[_vm._v(_vm._s(_vm.detail.userid))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号"}},[_c('div',{staticClass:"form-item__detail"},[_vm._v(_vm._s(_vm.detail.cellphone))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"省市区"}},[_c('div',{staticClass:"form-item__detail"},[_vm._v(_vm._s(_vm.regionText))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"累计完单数"}},[_c('div',{staticClass:"form-item__detail"},[_vm._v(_vm._s(_vm.detail.total_pass_order_count))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工单失效率"}},[_c('div',{staticClass:"form-item__detail"},[_c('span',{class:{ 'is-risk': _vm.isHighInvalidPercent(_vm.detail) }},[_vm._v(_vm._s(_vm.totalInvalidPercentText))])])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"风险状态"}},[_c('div',{staticClass:"form-item__detail"},[_c('span',{class:{ 'is-risk': _vm.isRiskStatus(_vm.detail)}},[_vm._v(_vm._s(_vm.riskStatusText))])])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"确认状态"}},[_c('div',{staticClass:"form-item__detail"},[_vm._v(_vm._s(_vm.confirmStatusText))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"负责人"}},[_c('div',{staticClass:"form-item__detail"},[_vm._v(_vm._s(_vm.adminusernameText))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"确认时间"}},[_c('div',{staticClass:"form-item__detail"},[_vm._v(_vm._s(_vm.detail.confirmed_at))])]),_vm._v(" "),(Number(_vm.detail.risk_status) === 1)?_c('el-form-item',{attrs:{"label":"风险触发条件"}},[_c('div',{staticClass:"form-item__detail"},[_vm._v("\n            "+_vm._s(_vm.riskReasons.join(','))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"触发风险时间"}},[_c('div',{staticClass:"form-item__detail"},[_vm._v("\n            "+_vm._s(_vm.detail.became_risk_at)+"\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"re-el-form_single_grid"},[_c('el-form-item',{staticClass:"risk-user-customer-stats-item",attrs:{"label":"单一客户完单率"}},[_c('div',{staticClass:"risk-user-customer-stats"},_vm._l((_vm.detail.customer_stats),function(item,index){return _c('div',{key:index,class:{ 'is-risk': _vm.isCustomerRisk(item) }},[_c('span',{staticStyle:{"display":"inline-block","min-width":"200px"}},[_vm._v(_vm._s(item.customername))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.order_percent)+"%")])])}),0)])],1),_vm._v(" "),_c('div',{staticClass:"re-el-form_single_grid"},[(_vm.detail.risk_status === 1)?_c('el-form-item',{attrs:{"label":"备注","required":""}},[_c('el-input',{attrs:{"type":"textarea","rows":3,"placeholder":"请输入备注信息","maxlength":"500","show-word-limit":""},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"re-el-form__flex"},[(_vm.detail.risk_status === 1)?_c('el-form-item',[_c('el-button',{attrs:{"type":"danger","loading":_vm.confirmLoading},on:{"click":_vm.onConfirmRisk}},[_vm._v("确认风险")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","loading":_vm.confirmLoading},on:{"click":_vm.onConfirmNormal}},[_vm._v("确认正常")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.push('/users/riskusers')}}},[_vm._v("返回列表")])],1):_vm._e()],1)])],1),_vm._v(" "),_c('layout-panel',{attrs:{"hide-collapse":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("确认日志")]},proxy:true}])},[_vm._v(" "),_c('el-table',{attrs:{"data":_vm.confirmLogList}},[_c('el-table-column',{attrs:{"prop":"logtime","label":"操作时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"adminusername","label":"操作人"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.adminusername)+" / "+_vm._s(scope.row.adminuserid)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"logtype","label":"日志类型"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"logcontent","label":"日志内容","show-overflow-tooltip":""}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/users-riskusers-detail.78926c3ce8a2b90cab0b.js